import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const defaultValues = {
  showProgress: true,
  showLogout: false,
  session: '',
  key: '',
  module: '',
  sideVisible: true,
  sideCollapsed: false,
  isMobile: false,
  token: ''
}

const updateConfig = (newConf: any) => {}
const ConfigContext = createContext({ config: defaultValues, updateConfig });

export const ConfigProvider = ({ children }: any) => {
  const [config, setConfig] = useState(defaultValues);
  const updateConfig = useCallback((newConfig: any) => {
    setConfig((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    config,
    updateConfig,
  }), [config, updateConfig]);

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};
